<template>
    <incoming-process readOnly></incoming-process>
</template>
<script>
import IncomingProcess from './IncomingProcess.vue'
export default {
    name: 'ViewIncomingProcess',
    components: {
        IncomingProcess
    }
}
</script>